/**
 * Application-wide configuration.
 *
 * API_BASE_URL
 * ------------
 * The root URL for the Django backend API.  In production this is read from the
 * REACT_APP_API_URL environment variable (set in Vercel → Settings → Env Vars).
 * In local development it falls back to the current Heroku deployment.
 *
 * When the backend moves to GCP (or any other host), update the env var in
 * Vercel — no code change required.
 */

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://obbackend.herokuapp.com';

export { API_BASE_URL };
